import { IOneway } from "src/models/IOneway";

export class Oneway implements IOneway {
  start_location = "";
  end_location = "";
  price = 0;
  currency = "";
}